import { render, staticRenderFns } from "./carouselB.vue?vue&type=template&id=a8aeaee2&scoped=true&"
import script from "./carouselB.vue?vue&type=script&lang=js&"
export * from "./carouselB.vue?vue&type=script&lang=js&"
import style0 from "./carouselB.vue?vue&type=style&index=0&id=a8aeaee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aeaee2",
  null
  
)

export default component.exports